import type {LibraryState, StudentAttempt} from "./activity-library";

export const attemptSessionId = (a: StudentAttempt) => a.currentSessionId ?? a.sessionId;
export const hasSavedWork = (a: StudentAttempt) => Object.values(a.answers).some(v => v.trim() && v !== "[]") || Object.values(a.photos ?? {}).some(p => p.length) || a.evidence.length > 0;
const dateOf = (s: LibraryState, a: StudentAttempt) => [a.lastSavedAt, a.completedAt, a.submittedAt, a.startedAt,
  s.digitalSessions?.find(d => d.id === attemptSessionId(a))?.startedAt,
  s.assignments.find(row => row.id === a.assignmentId)?.assignedAt].filter((v): v is string => !!v).sort().at(-1) ?? "";

export function latestWork(s: LibraryState, attempts: StudentAttempt[]) {
  const superseded = new Set(s.attempts.flatMap(a => a.continuedFromAttemptId ? [a.continuedFromAttemptId] : []));
  return attempts.filter(a => !superseded.has(a.id)).sort((a,b) => Number(hasSavedWork(b)) - Number(hasSavedWork(a)) || dateOf(s,b).localeCompare(dateOf(s,a)) || b.id.localeCompare(a.id))[0];
}

/** Call on the already owner-filtered student projection; archives remain in storage/history. */
export function currentStudentWork(s: LibraryState) {
  const byActivity = new Map<string, StudentAttempt[]>();
  const superseded = new Set(s.attempts.flatMap(a => a.continuedFromAttemptId ? [a.continuedFromAttemptId] : []));
  for (const a of s.attempts) {
    if (superseded.has(a.id)) continue;
    const key = `${a.classId}/${a.activityId}`;
    byActivity.set(key, [...(byActivity.get(key) ?? []), a]);
  }
  return [...byActivity.values()].map(attempts => {
    const open = attempts.filter(a => s.digitalSessions?.some(d => d.id === attemptSessionId(a) && d.access !== "ended"));
    return latestWork(s, open.length ? open : attempts)!;
  });
}
